import { c as _c } from "react/compiler-runtime";
import { Field } from "~/components/ui/field";
type AuthFieldProps = {
  id: string;
  label: string;
  type?: "text" | "email" | "password" | "tel";
  placeholder: string;
  autoComplete?: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
};
export function AuthField(t0) {
  const $ = _c(11);
  const {
    id,
    label,
    type: t1,
    placeholder,
    autoComplete,
    value,
    error,
    onChange
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = e => onChange(e.target.value);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== autoComplete || $[3] !== error || $[4] !== id || $[5] !== label || $[6] !== placeholder || $[7] !== t2 || $[8] !== type || $[9] !== value) {
    t3 = <Field id={id} label={label} type={type} placeholder={placeholder} autoComplete={autoComplete} value={value} error={error} onChange={t2} />;
    $[2] = autoComplete;
    $[3] = error;
    $[4] = id;
    $[5] = label;
    $[6] = placeholder;
    $[7] = t2;
    $[8] = type;
    $[9] = value;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}